import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/map';
import { timeout } from "rxjs/operator/timeout";


@Injectable()
export class LastpostsService {
    http: Http;

    lastArticlesDataChange = new Subject<void>();
    lastArticles = [];
    private lastArticlesData = [];

    constructor(http: Http) {
        this.http = http;
    }


    fetchLastArticles(media, category) {
        this.http.get(`/api/last-articles/${media}/%20`)
            .map((response: Response) => {
                const data = response.json();
                this.lastArticles = [
                    [
                        {
                            "posts": data.articles,
                            "active": data.active
                        }
                    ]
                ];
                return this.lastArticles;
            })
            .subscribe(
            (data) => {
                this.lastArticlesData = data;
                setTimeout(() => this.lastArticlesDataChange.next(), 1000 * 12);
            }
            );
    }
    fetchLastPosts() {
        return this.lastArticlesData[0];
    }


}


// WEBPACK FOOTER //
// /home/node/src/app/_services/lastposts.service.ts